// Hook for managing onboarding tour state
import { useState, useEffect, useCallback } from 'react'

export function useOnboardingTour() {
  const [showTour, setShowTour] = useState(false)

  useEffect(() => {
    // Check if user has completed the tour
    const hasCompletedTour = localStorage.getItem('framex_tour_completed')
    if (!hasCompletedTour) {
      // Small delay to let the page load
      const timer = setTimeout(() => setShowTour(true), 500)
      return () => clearTimeout(timer)
    }
  }, [])

  const completeTour = useCallback(() => {
    localStorage.setItem('framex_tour_completed', 'true')
    setShowTour(false)
  }, [])

  const skipTour = useCallback(() => {
    localStorage.setItem('framex_tour_completed', 'true')
    setShowTour(false)
  }, [])

  const resetTour = useCallback(() => {
    localStorage.removeItem('framex_tour_completed')
    setShowTour(true)
  }, [])

  return {
    showTour,
    completeTour,
    skipTour,
    resetTour,
  }
}
